/* istanbul ignore file */
import React from 'react';
import { CreateForm, FormTemplateProps } from 'framework/form';
import useAssetNoteService from 'domain/finance/assets/Timeline/note/assetNoteService';
import { CreateTimelineItemLayout } from 'framework/ui/timeline';
import NoteForm from 'domain/finance/assets/Timeline/note/form/NoteForm';

const CreateNoteForm = ({
  submitFormFunc,
  onCancel,
  ...props
}: {
  onCancel?: () => void;
} & FormTemplateProps) => {
  const { getValidationSchema } = useAssetNoteService();
  return (
    <CreateForm submitFormFunc={submitFormFunc} getValidationSchemaFunc={getValidationSchema} {...props}>
      <CreateTimelineItemLayout onCancel={onCancel}>
        <NoteForm />
      </CreateTimelineItemLayout>
    </CreateForm>
  );
};

export default CreateNoteForm;
